import request from '@/utils/request/request'

export function slide(data) {
  return request({
    url: '/v1/slide', //'/api/v1/login/doLogin',
    method: 'get',
    data
  })
}

// export function announcement(data) {
//   return request({
//     url: '/v1/announcement',
//     method: 'get',
//     data
//   })
// }


// nav分类
export function navCategory(data) {
  return request({
    url: '/v1/category',
    method: 'get',
    data
  })
}


// nav分类点击列表页面
export function navCategoryPage(data) {
  return request({
    url: '/v1/article',
    method: 'get',
    data
  })
}

// 友情链接
export function friendLinks(data) {
  return request({
    url: '/v1/links',
    method: 'get',
    data
  })
}

// 广告
export function getAdv(data) {
  return request({
    url: '/v1/adv',
    method: 'get',
    data
  })
}

// 网站基本信息
export function getSite(data) {
  return request({
    url: '/v1/site',
    method: 'get',
    data
  })
}


// 左侧继续教育
export function education(data) {
  return request({
    url: '/v1/education',
    method: 'get',
    data
  })
}


// 左侧学历提升
export function promote(data) {
  return request({
    url: '/v1/promote',
    method: 'get',
    data
  })
}


// 左侧学分查询
export function credit(data) {
  return request({
    url: '/v1/credit',
    method: 'get',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js